import { makeAutoObservable } from 'mobx';
import { CategoryOutput } from 'dtos/shared/jobDetails';
import { DiligenceCategoryStore } from 'stores/diligence/DiligenceCategoryStore';

export class DiligenceCategoriesStore {
  categories: DiligenceCategoryStore[];

  constructor(categories: CategoryOutput[]) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.categories = categories.map((category) => new DiligenceCategoryStore(category));
  }

  destroy() {
    this.categories.forEach((category) => category.destroy());
  }

  toggleCategory = (title: string) => {
    const foundCategory = this.categories.find((category) => category.title === title);
    if (!foundCategory) return;
    foundCategory.status = foundCategory.status === 'incomplete' ? 'submitted' : 'incomplete';
  };

  setCategorySubmitted = (title: string) => {
    const foundCategory = this.categories.find((category) => category.title === title);
    if (!foundCategory) return;
    foundCategory.status = 'submitted';
  };

  setCategoryIncomplete = (title: string) => {
    const foundCategory = this.categories.find((category) => category.title === title);
    if (!foundCategory) return;
    foundCategory.status = 'incomplete';
  };

  get incompleteCategories() {
    return this.categories.filter((category) => category.status === 'incomplete');
  }

  get submittedCategories() {
    return this.categories.filter((category) => category.status !== 'incomplete');
  }

  get totalCategories() {
    return this.categories.length;
  }

  get percentComplete() {
    const totalCategories = this.totalCategories;
    if (totalCategories === 0) return 0;
    return Math.floor((this.submittedCategories.length * 100) / totalCategories);
  }
}
